import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as staffActions from '../../Redux/Actions/staff';
import {toastMessage} from '../../utils/toast';
import { initiateLogOut } from '../../utils/initiate';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';

const StaffManagement = ({history}) => {

    let itemsPerPage = 10;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [errStatus, setErrStatus] = useState(200);
    const userData = useSelector(({User}) => User.data);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        staffActions.getAll().then(res => {
            if(res && res.data){
                setData(res.data);
            }else{
                toastMessage('error', 'Unable to load the staffs');
            }
            setLoading(false);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && initiateLogOut(userData.UserId, dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history]);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <div className="container-fluid">
            <div className="page-title-box">
                <h4 className="page-title my-2">{t("staffManagement.manageStaff.title")}</h4>
            </div>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card card-custom card-stretch gutter-b">
                        {loading ? <Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                        : <div className="card-body p-3">
                            <div className="tab-content">
                                <div className="table-responsive">
                                    <table className="table table-head-custom table-vertical-center table-head-bg">
                                        <thead>
                                            <tr className="text-left">
                                                <th className="c-pointer">{t("staffManagement.manageStaff.sNo")}</th>
                                                <th className="c-pointer">{t("staffManagement.manageStaff.name")}</th>
                                                <th className="c-pointer">{t("staffManagement.manageStaff.extensionNumber")}</th>
                                                <th className="c-pointer">{t("staffManagement.manageStaff.skills")}</th>
                                                <th className="c-pointer">{t("staffManagement.manageStaff.action")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentItems.map(({staffInfo, skillInfo}, index) => {
                                                return(
                                                    <tr key={index}>
                                                        <td className="pr-0">
                                                            <p className="font-weight-bolder font-size-sm">{index+1}</p>
                                                        </td>
                                                        <td className="pr-0">
                                                            <p className="font-weight-bolder font-size-sm">{staffInfo.name}</p>
                                                        </td>
                                                        <td className="pr-0">
                                                            <p className="font-weight-bolder font-size-sm">{staffInfo.extensionNumber}</p>
                                                        </td>
                                                        <td className="pr-0">
                                                            {(skillInfo.length === 0) ? <p className="text-muted font-size-sm">{t("staffManagement.manageStaff.noSkillsAssigned")}</p> : skillInfo.map(({name}) => <p key={name} className="font-weight-bolder font-size-sm">{name}</p>)}
                                                        </td>
                                                        <td className="pr-0">
                                                            <p className="btn btn-primary font-weight-bolder font-size-sm c-pointer" onClick={() => history.push(`/staff/update/${staffInfo.id}`)}>{t("staffManagement.manageStaff.update")}</p>
                                                        </td>
                                                    </tr>
                                                )})}
                                        </tbody>
                                    </table>
                                    {(pageCount > 1) && <ReactPaginate
                                        breakLabel="..."
                                        nextLabel=">"
                                        previousLabel="<"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />}
                                    {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("staffManagement.noDataAvailable")}</p>}
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StaffManagement;